import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  IconButton,
} from '@mui/material';
import { useState } from 'react';
import {
  Phone,
  ArrowBackIos,
  Send,
} from '@mui/icons-material';
import { triggerTypes } from './ccf-outbound-trigger-helper';

import styles from './ccf-outbound-trigger.module.scss';

interface ISkill {
  selected?: string;
  values: string[];
}

export interface ITriggerResponse {
  skill: string;
  trigger: boolean;
}
interface IProps {
  type: string;
  number?: string | number;
  skills?: ISkill;
  onTrigger: (triggerRes: ITriggerResponse) => void;
}

/**
 * Function to outbound trigger
 * @param props - IProps
 * @example <CcfOutboundTrigger />
 * @returns
 */
const CcfOutboundTrigger = (props: IProps) => {
  const [selectedSkill, setSkill] = useState<string>(
    props.skills?.selected || ''
  );

  /**
   * Function for skill change
   * @param event -any
   * @example onSkillChange()
   */
  const onSkillChange = (event: any) => {
    const value = event.target.value;
    if (value) setSkill(value);
  };

  /**
   * @example - trigger()
   */
  const trigger = () => {
    const response = { skill: selectedSkill, trigger: true };
    props.onTrigger(response);
  };

  /**
   * @example backHandler()
   */
  const backHandler = () => {
    const response = { skill: selectedSkill, trigger: false };
    props.onTrigger(response);
  };

  return (
    <div className={styles.triggerContainer}>
      <div className={styles.backContainer} id="btn-outbound-back">
        <div className={styles.arrowBackIcon}>
          <ArrowBackIos />
        </div>
        <div className={styles.backText} onClick={backHandler}>
          {' '}
          Back
        </div>
      </div>
      <hr className={styles.liner} />
      {props.type === triggerTypes.voice.type && (
        <div>
          <div className={styles.voiceContainer}>
            <div className={styles.voiceBox}>
              <div>
                <Phone className={styles.ccfIcon} />
              </div>
              <div className={styles.voiceText}>Voice Call</div>
            </div>
            <div>
              <span className={styles.numberFont}>{props.number}</span>
            </div>
          </div>
          <hr className={styles.liner} />
          <div className={styles.skillContainer}>
            <FormControl variant="outlined" style={{ width: '100%' }}>
              <InputLabel id="demo-simple-select-outlined-label">
                Select a Skill
              </InputLabel>
              <Select
                labelId="voice-call-select-label"
                id="voice-call-select"
                variant="outlined"
                value={selectedSkill}
                onChange={onSkillChange}
                label="Skill"
              >
                {(props.skills?.values || []).map(
                  (option: string, index: number) => {
                    return (
                      <MenuItem value={option} key={index}>
                        {option}
                      </MenuItem>
                    );
                  }
                )}
              </Select>
            </FormControl>
          </div>
          <div className={styles.submitContainer}>
            <IconButton
              className={
                !selectedSkill
                  ? styles.paperSendDisabled
                  : styles.paperSendEnabled
              }
              onClick={trigger}
              disabled={!selectedSkill}
            >
              <Send />
            </IconButton>
          </div>
        </div>
      )}
    </div>
  );
};

export default CcfOutboundTrigger;
